import { ChangeDetectorRef, Component, Input, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ChartConfiguration, ChartOptions, ChartType } from "chart.js";
import { monthsNumeric } from "../../../../consts";
import { ActualSelected, Utils } from "../../../../shared/utils";
import { BalanceDialogComponent } from "../../balance/balance-dialog.component";
import { ResumeDialogComponent } from "../../resume-dialog.component";
import { ResumeService } from "../../resume.service";
import { ResumeV2Model } from "../../resumeV2.model";

import { Router } from "@angular/router";
import { ReconciliationService } from "../../../conciliation/reconciliation.service";
import { ResumeTodayModel } from "../../resume-today.model";
import { DummyComponent } from "../../../../shared/dummy.component";
import { chartPalette, gradientFill, tooltipBase, legendBase, barScalesBase, barGeometry } from "../chart-theme";


@Component({
  selector: 'chart-resume-total',
  templateUrl: './chart-resume-total.component.html',
  styleUrls: ['../../resume.component.css'],
  standalone: false
})
export class ChartResumeTotalComponent implements OnInit, OnChanges {
  constructor(
    private resumeService: ResumeService,
    public dialog: MatDialog,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  @Input() dataV2: ResumeV2Model = new ResumeV2Model();

  @Input() resumeToday: any = {
    generalIncomes: 0,
    generalExpenses: 0,
    generalBalance: 0,
    ivaIncomes: 0,
    ivaExpenses: 0,
    ivaBalance: 0,
    igicIncomes: 0,
    igicExpenses: 0,
    igicBalance: 0,
  };


  @Input() showGlobal: boolean = false;

  public lineChartLabels: string[] = monthsNumeric;

  public resumeChartType: ChartType = 'bar';

  public resumeChartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.lineChartLabels,
    datasets: [
      {
        data: [],
        label: 'Ingresos',
        backgroundColor: gradientFill(chartPalette.income),
        hoverBackgroundColor: chartPalette.income,
        ...barGeometry
      },
      {
        data: [],
        label: 'Subvenciones',
        backgroundColor: gradientFill(chartPalette.grant),
        hoverBackgroundColor: chartPalette.grant,
        ...barGeometry
      },
      {
        data: [],
        label: 'Gastos',
        backgroundColor: gradientFill(chartPalette.expense),
        hoverBackgroundColor: chartPalette.expense,
        ...barGeometry
      }
    ]
  };

  public resumeChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 700, easing: 'easeOutQuart' },
    scales: barScalesBase(),
    plugins: {
      legend: legendBase(),
      tooltip: tooltipBase()
    }
  };

  totalBalance: number = 0;
  totalExpensesUnPaid: number = 0;
  totalIncomesPaid: number = 0;
  totalExpensesPaid: number = 0;
  totalIncomes: number = 0;
  totalExpenses: number = 0;
  totalIncomesUnPaid: number = 0;
  totalSubventions: number = 0;

  summaryModelRetention: any;

  businessAnalysis: any = null;
  businessAnalysisError = false;

  ngOnInit() {
    this.resumeService.getResumeModel({ isGlobal: this.showGlobal }).then(response => {
      this.summaryModelRetention = response.models;
      this.cdr.markForCheck();
    });

    this.setResumeData();

    this.resumeService.getBusinessAnalysis().then(data => {
      if (data != null) {
        this.businessAnalysis = data;
      } else {
        this.businessAnalysisError = true;
      }
      this.cdr.markForCheck();
    });

    this.resumeService.getDataSubject().subscribe(data => {
      if (!data) return;
      this.dataV2 = data.data;
      this.showGlobal = data.global;
      this.setResumeData();
    });
  }


  public lineChartOptions: any = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top'
      }
    },
    labelClasses: ['tu-clase-personalizada']
  };
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataV2'] || changes['showGlobal']) {
      this.setResumeData();
    }
  }

  openDialogBalance() {
    this.dialog.open(BalanceDialogComponent, {
      data: {
        activityUid: ActualSelected.activitySelected,
        showGlobal: this.showGlobal
      },
    });
  }

  openDialog(
    ExpensesPaided: boolean = false,
    IncomesPaided: boolean = false,
    ExpensesNoPaided: boolean = false,
    IncomesNoPaided: boolean = false
  ) {
    this.dialog.open(ResumeDialogComponent, {
      height: '70%',
      width: '70%',
      data: {
        activityUid: ActualSelected.activitySelected,
        expensesPaided: ExpensesPaided,
        expensesNoPaided: ExpensesNoPaided,
        incomesPaided: IncomesPaided,
        incomesNoPaided: IncomesNoPaided,
        showGlobal: this.showGlobal
      },
    });
  }

  changeGlobal() {
    this.setResumeData();
  }

  public chartClicked(e: any): void { }

  public chartHovered(e: any): void { }

  SetTotales() {
    try {
      this.totalIncomesPaid = Utils.GetValueWithDecimals(this.dataV2.incomesPaid?.[12]?.total || 0);
      this.totalIncomesUnPaid = Utils.GetValueWithDecimals(this.dataV2.incomesUnPaid?.[12]?.total || 0);
      this.totalSubventions = Utils.GetValueWithDecimals(this.dataV2.subventions?.[12]?.total || 0);
      this.totalIncomes = Utils.GetValueWithDecimals(this.dataV2.incomes?.[12]?.total || 0);

      this.totalExpensesPaid = Utils.GetValueWithDecimals(this.dataV2.expensesPaid?.[12]?.total || 0);
      this.totalExpensesUnPaid = Utils.GetValueWithDecimals(this.dataV2.expensesUnPaid?.[12]?.total || 0);
      this.totalExpenses = Utils.GetValueWithDecimals(this.dataV2.expenses?.[12]?.total || 0);

      this.totalBalance = Utils.GetValueWithDecimals(
        (this.totalIncomes + this.totalSubventions) - this.totalExpenses
      );
    } catch (_) { }
  }

  SetResumeIncomes() {
    this.setChartsData();
    this.SetTotales();
  }

  SetResumeExpenses() {
    this.setChartsData();
    this.SetTotales();
  }

  setResumeData() {
    this.SetResumeIncomes();
    this.SetResumeExpenses();
  }

  updateValues() {
    this.setChartsData();
  }

  setChartsData() {
    this.resumeChartData = {
      labels: this.lineChartLabels,
      datasets: [
        {
          data: this.dataV2.incomes?.slice(0, 12).map(a => a.total) ?? [],
          label: 'Ingresos',
          backgroundColor: gradientFill(chartPalette.income),
          hoverBackgroundColor: chartPalette.income,
          ...barGeometry
        },
        {
          data: this.dataV2.subventions?.slice(0, 12).map(a => a.total) ?? [],
          label: 'Subvenciones',
          backgroundColor: gradientFill(chartPalette.grant),
          hoverBackgroundColor: chartPalette.grant,
          ...barGeometry
        },
        {
          data: this.dataV2.expenses?.slice(0, 12).map(a => a.total) ?? [],
          label: 'Gastos',
          backgroundColor: gradientFill(chartPalette.expense),
          hoverBackgroundColor: chartPalette.expense,
          ...barGeometry
        }
      ]
    };

    const totalExpenseIgicChart: number[] = new Array(12).fill(0);
    for (let i = 0; i < (this.dataV2.expensesIgic?.length || 0); i++) {
      totalExpenseIgicChart[i] = Utils.GetValueWithDecimals(
        (this.dataV2.expensesIgic?.[i]?.total || 0) +
        (this.dataV2.investmentIgic?.[i]?.total || 0) +
        (this.dataV2.expensesIgicImport?.[i]?.total || 0)
      );
    }
  }

  public percentageOfSalesProfitability(ingresos: number, gasto: number): number {
    const firstResult = ingresos - gasto;

    if (firstResult < 0) {
      return 0;
    }

    const secondResult = firstResult / ingresos;

    if (!secondResult) {
      return 0;
    }

    let finalResult = secondResult * 100;
    finalResult = Utils.GetValueWithDecimals(finalResult);
    return finalResult;
  }

  redirectCashFlow() {
    this.router.navigate(['/accounting/reports/cash-flow']);
  }
  public trackByIndex(i: number) { return i; }

}